import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c47ff6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue-tl-billing-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Billing Details", -1 /* HOISTED */))
const _hoisted_3 = { class: "billing-invoices" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Invoices", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date Issued"),
    /*#__PURE__*/_createElementVNode("th", null, "For"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Paid Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Paid With"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Download")
  ])
], -1 /* HOISTED */))
const _hoisted_6 = ["title"]
const _hoisted_7 = ["title"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "billing-subscriptions" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Active Subscriptions", -1 /* HOISTED */))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Program"),
    /*#__PURE__*/_createElementVNode("th", null, "Frequency"),
    /*#__PURE__*/_createElementVNode("th", null, "Next Payment"),
    /*#__PURE__*/_createElementVNode("th", null, "Card"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount")
  ])
], -1 /* HOISTED */))
const _hoisted_14 = ["title"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "card-update-container" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_downloadIcon = _resolveComponent("downloadIcon")!
  const _component_CardChooserComponent = _resolveComponent("CardChooserComponent")!
  const _component_ToolTipComponent = _resolveComponent("ToolTipComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("table", null, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownInvoices, (invoice) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: invoice.Id,
              class: _normalizeClass(`status-${_ctx.toKebabCase(invoice.Status)}`)
            }, [
              _createElementVNode("td", {
                title: invoice.Id
              }, _toDisplayString(_ctx.displayDate(invoice.CreatedDate)), 9 /* TEXT, PROPS */, _hoisted_6),
              _createElementVNode("td", null, _toDisplayString(invoice.PlanName), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(invoice.Status), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(invoice.PaidDate && _ctx.displayDate(invoice.PaidDate)), 1 /* TEXT */),
              _createElementVNode("td", null, _toDisplayString(invoice.PaidWithCopy), 1 /* TEXT */),
              _createElementVNode("td", {
                title: invoice.Tax ? `Including ${_ctx.formatCents(invoice.Tax)} ${invoice.TaxName}` : ''
              }, _toDisplayString(invoice.CurrencyCode ?? '') + _toDisplayString(_ctx.formatCents(invoice.Total)), 9 /* TEXT, PROPS */, _hoisted_7),
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: invoice.DownloadUrl,
                  title: "Download PDF invoice",
                  download: "Invoice",
                  target: "_blank"
                }, [
                  _createVNode(_component_downloadIcon)
                ], 8 /* PROPS */, _hoisted_8)
              ])
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        (!_ctx.showAllInvoices && (_ctx.invoices.length > _ctx.shownInvoices.length))
          ? (_openBlock(), _createElementBlock("tfoot", _hoisted_9, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  colspan: "999",
                  role: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showAllInvoices = true;})
                }, " Show all invoices ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _hoisted_11,
      (_ctx.activeAndFutureSubscriptions.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeAndFutureSubscriptions, (subscription) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: subscription.Id
                }, [
                  _createElementVNode("td", {
                    title: `Start date: ${_ctx.displayDate(subscription.StartDate)}`
                  }, _toDisplayString(subscription.PlanName), 9 /* TEXT, PROPS */, _hoisted_14),
                  _createElementVNode("td", null, [
                    _createTextVNode(" Every " + _toDisplayString(subscription.BillingPeriod) + " " + _toDisplayString(_ctx.pluralize(subscription.FrequencyTimespan.toLowerCase(), subscription.BillingPeriod)) + " ", 1 /* TEXT */),
                    (subscription.RemainingBillingCycles > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " for " + _toDisplayString(subscription.RemainingBillingCycles) + " " + _toDisplayString(_ctx.pluralize(subscription.FrequencyTimespan.toLowerCase(), subscription.RemainingBillingCycles)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(subscription.NextBillingDate && _ctx.displayDate(subscription.NextBillingDate)), 1 /* TEXT */),
                  _createElementVNode("td", null, _toDisplayString(subscription.PaidWithCardLastFour), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_16, [
                    _createVNode(_component_ToolTipComponent, { class: "subscription-card-tooltip" }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn card-update-button",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                        }, " update ")
                      ]),
                      content: _withCtx(() => [
                        _createVNode(_component_CardChooserComponent, {
                          "always-show": true,
                          "subscription-id": subscription.Id,
                          onSelectedCardChanged: _ctx.subscriptionCardChanged
                        }, null, 8 /* PROPS */, ["subscription-id", "onSelectedCardChanged"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _createElementVNode("td", {
                    title: subscription.Taxable ? 'Plus GST where applicable' : ''
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.formatCents(subscription.Total)), 1 /* TEXT */),
                    (subscription.Taxable)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_17)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : (_openBlock(), _createElementBlock("h4", _hoisted_19, " No active subscriptions "))
    ]),
    _createVNode(_component_LoadingComponent, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"])
  ]))
}